var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGitIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_996_200)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.3026 40.99L49.0078 1.69726C46.7462 -0.565752 43.0759 -0.565752 40.8115 1.69726L32.6517 9.85702L43.0028 20.2081C45.4082 19.3953 48.1665 19.9405 50.0839 21.858C52.0105 23.7877 52.5519 26.5696 51.7194 28.9827L61.695 38.9587C64.1085 38.1272 66.8932 38.6651 68.8208 40.5959C71.5148 43.2889 71.5148 47.6535 68.8208 50.3482C66.1261 53.0433 61.7614 53.0433 59.0653 50.3482C57.0389 48.3197 56.5383 45.3437 57.5641 42.8473L48.2611 33.5442L48.26 58.026C48.9344 58.3595 49.5504 58.7999 50.0839 59.3303C52.778 62.0233 52.778 66.3883 50.0839 69.0851C47.3892 71.7788 43.0225 71.7788 40.3316 69.0851C37.6376 66.3883 37.6376 62.0236 40.3316 59.3307C40.9772 58.6847 41.7445 58.1732 42.589 57.8256V33.1157C41.7432 32.7704 40.9755 32.2586 40.3316 31.6107C38.2904 29.5723 37.7996 26.5773 38.8455 24.071L28.6418 13.8662L1.69805 40.8082C-0.566016 43.0734 -0.566016 46.744 1.69805 49.0074L40.9936 88.3008C43.2559 90.5642 46.9255 90.5642 49.1906 88.3008L88.3023 49.1898C90.5657 46.9258 90.566 43.253 88.3026 40.99Z",
    fill: "#DE4C36"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_996_200"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 90,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGitIcon);
export default __webpack_public_path__ + "static/media/git_icon.72d138b95ec3640fc4febfdd679f3c61.svg";
export { ForwardRef as ReactComponent };